export const tintPartsSedan = {
  frontglass: "images/simulator-images/sedan_/tint/tint_fronts_5.png",
  rearsideglass: "images/simulator-images/sedan_/tint/tint_rears_5.png",
  rearwindshield: "images/simulator-images/sedan_/tint/tint_rearws_5.png",
  windshieldbrow: "images/simulator-images/sedan_/tint/tint_ws_brow_5.png",
};

export const tintPartsTruck = {
  frontglass: "images/simulator-images/truck_/tint/fronts.png",
  rearsideglass: "images/simulator-images/truck_/tint/rears.png",
  rearwindshield: "images/simulator-images/truck_/tint/rearws.png",
  windshieldbrow: "images/simulator-images/truck_/tint/brow.png",
};

export const tintPartsSuv = {
  frontglass: "images/simulator-images/suv_/tint/fronts.png",
  rearsideglass: "images/simulator-images/suv_/tint/rears.png",
  rearwindshield: "images/simulator-images/suv_/tint/rearws.png",
  windshieldbrow: "images/simulator-images/suv_/tint/brow.png",
};
